import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SvgIcon } from '@web/shared/ui';
import { HeaderIconComponent } from '../header-icon/header-icon.component';
import { Route, RouterLinkComponent } from '@web/common';

@Component({
  selector: 'app-header-cart-link',
  imports: [HeaderIconComponent, RouterLinkComponent],
  templateUrl: './header-cart-link.component.html',
  styleUrl: './header-cart-link.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderCartLinkComponent {
  public readonly totalItems = input.required<number>();

  protected readonly SvgIcon = SvgIcon;
  protected readonly Route = Route;
}
